import { defineComponent as _defineComponent } from 'vue'
import { getChildModel, makeFormModel, setState } from 'ah-common-lib/src/form/helpers';
import { emailField, selectField, textField } from 'ah-common-lib/src/form/models';
import { personTitles } from 'ah-common-lib/src/form/formModels';
import { ValidatedForm } from 'ah-common-lib/src/form/components';
import {
  defineManagedModelFormEmits,
  defineManagedModelFormProps,
  useManagedModelForm,
} from 'ah-common-lib/src/form/useManagedModelForm';


import { ClientInviteCreateRequest } from 'ah-api-gateways';
export type InviteClientDetails = Pick<
  ClientInviteCreateRequest,
  'applicantTitle' | 'applicantFirstName' | 'applicantLastName' | 'applicantEmail'
>;

export default /*#__PURE__*/_defineComponent({
  __name: 'InviteClientDetailsForm',
  props: {
  ...defineManagedModelFormProps<InviteClientDetails>(),
},
  emits: defineManagedModelFormEmits<InviteClientDetails>(),
  setup(__props, { expose, emit }) {

const props = __props;





const { formDef } = useManagedModelForm({
  props,
  emit,
  formModel: makeFormModel({
    name: 'ClientDetailsForm',
    title: 'Client Details',
    fieldType: 'form',
    state: {
      showRequiredMarkers: true,
    },
    fields: [
      selectField('applicantTitle', 'Title', personTitles, {
        fieldWrapperClass: 'col col-2 pr-0',
        required: true,
        appendToBody: true,
        placeholder: 'Mr.',
      }),
      textField('applicantFirstName', 'First name', {
        fieldWrapperClass: 'col-5 pr-0',
        required: true,
        placeholder: 'First Name',
      }),
      textField('applicantLastName', 'Surname', {
        fieldWrapperClass: 'col-5',
        required: true,
        placeholder: 'Last Name',
      }),
      emailField('applicantEmail', 'Email', { required: true, placeholder: 'Email' }),
    ],
  }),
});

expose({
  setEmailConflictError(error: boolean) {
    const emailField = getChildModel(formDef.form, 'applicantEmail')!;
    setState(
      emailField,
      'errors',
      error
        ? [
            {
              name: 'emailConflict',
              error: 'Duplicated email address',
            },
          ]
        : []
    );
  },
});

return { __sfc: true,props, emit, formDef, ValidatedForm }
}

})